import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { MegaMenuItem } from 'primeng/api';
import { LayoutService } from './service/app.layout.service';
 import { environment } from 'src/envs/environnement';
import {Router} from "@angular/router";
import { CurrentUserService } from '../renew/services/current-user.service';
import { GeneralService } from '../renew/services/general-service';
import { NotificationSocketService } from '../renew/services/notification-socket.service';
import { StructureCouranteService } from '../renew/services/structure-courante.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html'
})
export class AppTopbarComponent implements  OnInit, OnDestroy{

    @ViewChild('menuButton') menuButton!: ElementRef;

    @ViewChild('mobileMenuButton') mobileMenuButton!: ElementRef;

    @ViewChild('searchInput') searchInput!: ElementRef;
    currentUser: any = JSON.parse(sessionStorage.getItem('currentUser') || 'null');
    photoLoadError = false;
structureName=""
// "null"/"undefined" en toutes lettres si jamais stockes ainsi par erreur
// (voir rechargerStructure) : truthy en JS, donc a exclure explicitement.
structureNameId=(() => {
    const v = sessionStorage.getItem("courrante");
    return (v && v !== "null" && v !== "undefined") ? v : null;
})()
    private notificationSub?: Subscription;

    constructor(private router:Router,public generalService:GeneralService,public layoutService: LayoutService, public el: ElementRef,private currentUserService:CurrentUserService,private notificationSocketService:NotificationSocketService,private structureCouranteService:StructureCouranteService) {

    }
        endpoint=environment.baseUrl+"/utilisateur/"

    get urlPhotoProfil(): string {
        const photo = (this.currentUser?.photoProfile || '').replace(/;+$/, '').trim();
        return environment.baseUrl + '/files/download/' + photo;
    }

    ngOnInit() {
        this.currentUserService.currentUser.subscribe(user => {
            if (user) {
                this.currentUser = user;
                this.photoLoadError = false;
            }
        });

        // Si photoProfile est absent (backend ne le renvoie pas au login),
        // on recharge le profil complet depuis l'API pour l'obtenir.
        if (this.currentUser?.id && !this.currentUser?.photoProfile) {
            this.generalService.getById('utilisateur', this.currentUser.id).subscribe({
                next: (user: any) => {
                    if (user?.photoProfile) {
                        this.currentUser = { ...this.currentUser, photoProfile: user.photoProfile };
                        this.currentUserService.setCurrentUser(this.currentUser);
                    }
                },
                error: () => {}
            });
        }

        this.getListStructure();
        if(this.structureNameId){
            this.generalService.getById("structures",this.structureNameId).subscribe({
                next:(response)=>{
                    this.structureName=response?.nom
                    this.selectedStructure=response
                },
                error:(errors)=>{

                },
                complete:console.log
            })




        }



        // Charge les notifications non lues existantes une fois au demarrage,
        // puis le websocket pousse les nouvelles en temps reel (remplace le
        // setInterval de polling qui etait ici auparavant).
        this.searchNotification();
        this.notificationSocketService.connect();
        this.notificationSub = this.notificationSocketService.notification$.subscribe(notif => {
            this.notifications = [notif, ...this.notifications];
        });
    }

    ngOnDestroy(): void {
        this.notificationSub?.unsubscribe();
        this.notificationSocketService.disconnect();
    }
    getListStructure(){
        this.generalService.getList("structures/mes-structures-gerer").subscribe({
            next:(response)=>{
                this.structures=response;
                // Auto-selectionner la premiere structure si aucune n'est active
                if (!this.structureNameId && response.length > 0) {
                    const premiere = response[0];
                    this.selectedStructure = premiere.id;
                    this.structureName = premiere.nom;
                    this.structureCouranteService.setStructure(premiere.id);
                }
            },
            error:(errors)=>{},
            complete:console.log
        })
    }
 selectedStructure: any = null;

 // Reste vide tant que getListStructure() (appelee au ngOnInit) n'a pas
 // recu la vraie liste : evite d'afficher des entreprises factices dans le
 // selecteur si l'appel echoue ou tarde.
 structures: any[] = [];
    rechargerStructure(){
        if (!this.selectedStructure) {
            return;
        }
        // Mise a jour reactive : le menu et le dashboard s'actualisent via
        // leur abonnement a StructureCouranteService, sans rechargement de page.
        const found = this.structures.find((s: any) => s.id === this.selectedStructure);
        this.structureName = found?.nom || '';
        this.structureCouranteService.setStructure(this.selectedStructure);
    }
    logout(){
        this.notificationSocketService.disconnect();
        sessionStorage.removeItem("currentUser")
        sessionStorage.removeItem("token")
        this.router.navigateByUrl("/")
    }
    updateNotification(item:any){
        // L'API ne renvoie pas la liste mise a jour (juste un 200 vide) :
        // "this.notifications = response" ecrasait donc la liste entiere avec
        // une valeur vide des le premier clic. On retire juste l'element
        // marque comme lu, localement.
        this.generalService.updatebyId("notifications/"+item.id+"/lue",item.id,item).subscribe({
            next:()=>{
                this.notifications = this.notifications.filter(n => n.id !== item.id);
            },
            error:(error)=>{

            }
        })

    }
notifications:any[]=[]
    searchNotification(){
        this.generalService.getList("notifications/non-lus/utilisateur/"+this.currentUser.id).subscribe({
            next:(response)=>{
                this.notifications=response
            },
            error:(error)=>{

            }
        })
    }

    get notificationsBadge(): string {
        return this.notifications.length > 0 ? this.notifications.length.toString() : '';
    }

    get topbarInitiales(): string {
        const p = (this.currentUser?.prenom || '?').charAt(0).toUpperCase();
        const n = (this.currentUser?.nom || '').charAt(0).toUpperCase();
        return p + n;
    }

    activeItem!: number;


    get mobileTopbarActive(): boolean {
        return this.layoutService.state.topbarMenuActive;
    }

    onMenuButtonClick() {
        this.layoutService.onMenuToggle();
    }

    onRightMenuButtonClick() {
        this.layoutService.openRightSidebar();
    }

    onMobileTopbarMenuButtonClick() {
        this.layoutService.onTopbarMenuToggle();
    }

    focusSearchInput(){
       setTimeout(() => {
         this.searchInput.nativeElement.focus()
       }, 0);
    }
}
